import { render } from "./AddNewLeadModal.vue?vue&type=template&id=c7da8618&ts=true"
import script from "./AddNewLeadModal.vue?vue&type=script&lang=ts"
export * from "./AddNewLeadModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__